/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createTourOperatorUpgradeFromDiscriminatorValue, type TourOperatorUpgrade } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /AllotmentUpgrade/TourOperators
 */
export interface TourOperatorsRequestBuilder extends BaseRequestBuilder<TourOperatorsRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<TourOperatorUpgrade[]>}
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<TourOperatorUpgrade[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const TourOperatorsRequestBuilderUriTemplate = "{+baseurl}/AllotmentUpgrade/TourOperators";
/**
 * Metadata for all the requests in the request builder.
 */
export const TourOperatorsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: TourOperatorsRequestBuilderUriTemplate,
        responseBodyContentType: "text/plain;q=0.9",
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createTourOperatorUpgradeFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
